import type { MailboxInfo } from 'owa-client-types';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

/**
 * Returns the global settings account mailbox info if the given mailbox info is a unified inbox mailbox info,
 * otherwise returns the given mailbox info unchanged.
 */
export default function getUnifiedInboxResolvedMailboxInfoOrSelf(
    mailboxInfo: MailboxInfo
): MailboxInfo {
    return isUnifiedInboxMailboxInfo(mailboxInfo)
        ? getGlobalSettingsAccountMailboxInfo()
        : mailboxInfo;
}
